import { fetchApi } from '@/shared/api/fetchApi';

export interface CarStats {
  id: string;
  free_days: number;
  busy_days: number;
  nearest_rent?: {
    id: string;
    status: string;
    start_date: string;
    end_date: string;
    start_time: string;
    end_time: string;
    address_to_drop: string;
    address_to_deliver: string;
  };
}

interface StatsResponse {
  data: CarStats[];
  period: number;
}

export type StatsPeriod =
  | 'month'
  | 'previous-month'
  | 'current-year'
  | 'previous-year'
  | 'all'
  | `${Lowercase<string>}-${number}`; // для формата "jan-2024"

interface GetStatsParams {
  period: StatsPeriod;
}

export const carStatsApi = {
  getStats: async (period: StatsPeriod = 'month', carId?: string): Promise<StatsResponse> => {
    let startDateStr = '';
    let endDateStr = '';

    try {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      // TODO: Refactor these conditions
      if (period === 'current-year') {
        startDateStr = `${currentYear}-01-01`;
        endDateStr = `${currentYear + 1}-01-01`;
      }
      else if (period === 'previous-year') {
        startDateStr = `${currentYear - 1}-01-01`;
        endDateStr = `${currentYear}-01-01`;
      }
      else if (period === 'previous-month') {
        const prevMonth = currentMonth - 1;
        const year = prevMonth < 0 ? currentYear - 1 : currentYear;
        const month = prevMonth < 0 ? 11 : prevMonth;

        startDateStr = `${year}-${String(month + 1).padStart(2, '0')}-01`;
        const lastDay = new Date(year, month + 1, 0).getDate();
        endDateStr = `${year}-${String(month + 1).padStart(2, '0')}-${lastDay}`;
      }
      else if (period === 'month') {
        startDateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-01`;
        const lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
        endDateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${lastDay}`;
      }
      else if (period === 'all') {
        startDateStr = `${currentYear - 1}-${String(currentMonth + 1).padStart(2, '0')}-01`;
        const lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
        endDateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${lastDay}`;
      }
      else if (typeof period === 'string' && period.includes('-')) {
        const [monthStr, yearStr] = period.split('-');
        const year = parseInt(yearStr);
        const monthIndex = new Date(Date.parse(`${monthStr} 1, 2000`)).getMonth();

        startDateStr = `${year}-${String(monthIndex + 1).padStart(2, '0')}-01`;
        const lastDay = new Date(year, monthIndex + 1, 0).getDate();
        endDateStr = `${year}-${String(monthIndex + 1).padStart(2, '0')}-${lastDay}`;
      }

      if (!startDateStr || !endDateStr || startDateStr.includes('NaN') || endDateStr.includes('NaN')) {
        throw new Error(`Invalid dates generated for period: ${period}`);
      }

      return fetchApi<StatsResponse>('/api/v1/cars/statistics', {
        method: 'POST',
        body: JSON.stringify({
          filters: {
            start_date: startDateStr,
            end_date: endDateStr,
            car_id: carId
          },
          sort: {
            occupancy: 'asc',
            free_days: 'asc',
            price: 'asc'
          }
        })
      });
    } catch (error) {
      console.error('Error in getStats:', {
        error,
        period,
        startDateStr,
        endDateStr
      });
      throw error;
    }
  }
};
